export default "__VITE_ASSET__oT52kL9a__"